import { defineComponent, h, PropType, reactive, Teleport } from 'vue'
import KModal from './KModal.vue'

export default defineComponent({
  emits: ['close'],
  props: {
    variant: {
      type: String as PropType<'transparent' | 'base'>,
      default: 'base'
    },
    ariaModalLabel: {
      type: String,
      default: 'Modal Base'
    }
  },
  setup (props, { slots, emit }) {
    return () => {
      return h(
        Teleport,
        { to: '#modal-target' },
        h(KModal, {
          ...reactive(props),
          onClose: () => emit('close')
        }, slots)
      )
    }
  }
})
